module.exports = __webpack_public_path__ + "img/m_logo.44d394e5.png";